// @catalog F.010
/**
 * applyEconomicsOverlay — B5.2 (consume B5.1).
 *
 * Overlay de los números económicos canónicos que el backend calcula en el
 * endpoint de compra (POST /forecasting/calc, campo `economics`): el costo y el
 * precio unitario del dialog pasan a ser los del calc result — única fuente de
 * verdad — en lugar de los derivados del ProductData del front. Así pantalla,
 * gran total, PO y CSV usan el MISMO unitCost/sellingPrice por SKU y se eliminan
 * los "4 valores por producto" que detectó la auditoría F6.
 *
 * Función pura (testeable + memoizable). Un producto sin economics en el mapa, o
 * con costo/precio null, conserva su valor previo (degradación graceful).
 */

import { SelectedProduct } from "../../components/Forecast/SelectedProducts.types";

/** Espejo del `economics` que expone el backend (CalcForecastResultItem). */
export interface LineEconomics {
  /** Costo unitario de reposición CON IVA real; null si no hay costo. */
  unitCost: number | null;
  /** Precio de venta unitario CON IVA; null si no hay precio. */
  unitPrice: number | null;
  /** cantidad final × unitCost (0 si no hay costo). */
  total: number;
  /** cantidad final × (unitPrice − unitCost); null si falta precio o costo. */
  margin: number | null;
}

export function applyEconomicsOverlay(
  rows: SelectedProduct[],
  economicsById: Map<string, LineEconomics | undefined>,
): SelectedProduct[] {
  return rows.map((p) => {
    const e = economicsById.get(p.unifiedProductId);
    if (!e) return p;
    return {
      ...p,
      lastPurchaseCost: e.unitCost ?? p.lastPurchaseCost ?? null,
      sellingPrice: e.unitPrice ?? p.sellingPrice ?? null,
    };
  });
}
